import React, { useState } from 'react';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import routes from './SideBarRoutes';
import { useNavigate } from 'react-router-dom';
import IconButton from '@material-ui/core/IconButton';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import useMediaQuery from '@material-ui/core/useMediaQuery';

export const drawerWidth = 270;
export const useStyles = makeStyles((theme) => ({
  list: {
    [theme.breakpoints.up('sm')]: {
      marginLeft: '8px',
    },
  },
  backButtonHidden: {
    ...theme.mixins.toolbar,
    visibility: 'hidden',
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  listItem: {
    margin: '10px 0',
  },
  drawerPaper: {
    width: drawerWidth,
  },
  menuButton: {
    marginRight: 36,
  },

  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: 0,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9) + 1,
    },
  },
}));

export function Sidebar(props) {
  const { handleDrawerToggle } = props;
  const classes = useStyles();
  const navigate = useNavigate();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));

  const selectHandlerWeb = (item) => {
    navigate(`/app${item.to}`);
  };
  const selectHandler = (item) => {
    navigate(`/app${item.to}`);
    handleDrawerToggle();
  };
  return (
    <React.Fragment>
      {matches ? (
        <Drawer
          variant="persistent"
          anchor="left"
          open={props.open}
          classes={{
            paper: classes.drawerPaper,
          }}
        >
          <div
            className={clsx({
              [classes.toolbarIcon]: props.open,
              [classes.backButtonHidden]: !props.open,
            })}
          >
            <IconButton
              className={clsx(classes.backButtonHidden && !props.open)}
              onClick={props.handleDrawerToggle}
            >
              <ChevronLeftIcon />
            </IconButton>
          </div>
          <List className={classes.list}>
            {routes.map((item, index) => (
              <>
                <ListItem
                  button
                  onClick={() => selectHandler(item)}
                  key={index}
                  className={classes.listItem}
                >
                  <ListItemIcon>{item.Icon}</ListItemIcon>
                  <ListItemText primary={item.text} />
                </ListItem>
                <Divider variant="middle" />
              </>
            ))}
          </List>
        </Drawer>
      ) : (
        <Drawer
          variant="permanent"
          anchor="left"
          className={clsx(classes.drawer, {
            [classes.drawerOpen]: props.open,
            [classes.drawerClose]: !props.open,
          })}
          classes={{
            paper: clsx({
              [classes.drawerOpen]: props.open,
              [classes.drawerClose]: !props.open,
            }),
          }}
        >
          <div
            className={clsx({
              [classes.toolbarIcon]: props.open,
              [classes.backButtonHidden]: !props.open,
            })}
          >
            <IconButton
              className={clsx(classes.backButtonHidden && !props.open)}
              onClick={props.handleDrawerToggle}
            >
              <ChevronLeftIcon />
            </IconButton>
          </div>
          <List className={classes.list}>
            {routes.map((item, index) => (
              <>
                <ListItem
                  button
                  onClick={() => selectHandlerWeb(item)}
                  key={index}
                  className={classes.listItem}
                >
                  <ListItemIcon>{item.Icon}</ListItemIcon>
                  <ListItemText primary={item.text} />
                </ListItem>
                <Divider variant="middle" />
              </>
            ))}
          </List>
        </Drawer>
      )}
    </React.Fragment>
  );
}
